define('services/common/userAuth',['app'], function (app) {
    app.factory('userAuth', ['$q', '$state', '$rootScope', 'OpenUp', 'UserInfo', 'auiDialog', 'serviceresource', function ($q, $state, $rootScope, OpenUp, UserInfo, auiDialog, serviceresource) {
        var roleConfigs;
        var channelConfigs;

        function init(Model) {
            var defer = $q.defer();
            //使用缓存
            UserInfo.allowLogin(true).then(function (res) {
                if (res.isAllowLogin == 1 && !res.url) {
                    defer.resolve(true);
                } else if (res.isAllowLogin == 1 && res.url) {
                    AUI.BaseJSUtil.redirectUrl(res.url);
                } else {
                    if (res.isAllowLogin == 0 && res.isPopProxyRole) {
                        Model.userInfo.isShowAccountChange = Model.userInfo && Model.userInfo.userRouteInfo && Model.userInfo.userRouteInfo.userRouteInfoList && Model.userInfo.userRouteInfo.userRouteInfoList.length > 1;
                        auiDialog.fail('资料审核中', '您的实名认证资料已提交成功正在审核，请耐心等待！', function () {
                            AUI.BaseJSUtil.redirectUrl(systemParaConf.user.indexUrl);
                            defer.reject();
                        });
                    } else {
                        AUI.BaseJSUtil.redirectUrl(systemParaConf.user.indexUrl);
                        defer.reject();
                        return defer.promise;
                    }

                }
            }).catch(function () {
                defer.reject();
                return defer.promise;
            });
            return defer.promise;
        }

        //是否合作中心进入
        function isFromPartner(){
            var urlBeforeLogin = AUI.HDGWCall.getCookieOrSessionSt("urlBeforeLogin");
            if (urlBeforeLogin && urlBeforeLogin.indexOf("partnerCenter") > 0 &&
                urlBeforeLogin.indexOf("channel") > 0 && urlBeforeLogin.indexOf("roleID") > 0) {
                return true;
            }
            return false;
        }

        //获取业务来源的渠道和角色,获取不到返回null
        function getPartnerParam(args) {
            if(isFromPartner()){
                var urlBeforeLogin = AUI.HDGWCall.getCookieOrSessionSt("urlBeforeLogin");
                //获取url？开始到#结束，中间的参数部分
                var params = unescape(urlBeforeLogin).split("?")[1].split("#")[0];
                //参数部分是&链接，再分割为数组
                var paramList = params.split("&");

                var theRequest = {};
                for(var index in paramList){
                    var param = paramList[index].split("=");
                    theRequest[param[0]] =  param[1];
                }
                return theRequest[args];
            }else{
                return null;
            }
        }

        //获取业务渠道对应的渠道配置
        function getChannelConfigs(refresh){
            var defer = $q.defer();

            if(channelConfigs && !refresh){
                defer.resolve(channelConfigs);
            }else{
                OpenUp.getChannelConfig({req:{
                    language:'zh_CN',
                    channelType : getPartnerParam("channel")
                }}).then(function(res){
                    if(res.resultCode == 0 && res.channelConfigList && res.channelConfigList.length == 1){
                        channelConfigs = res.channelConfigList[0];
                        defer.resolve(channelConfigs);
                    }else{
                        defer.reject();
                    }
                },function(){
                    defer.reject();
                });
            }
            return defer.promise;
        }

        function getRoleConfigs(refresh,roleID){
            var defer = $q.defer();
            if(roleConfigs && !refresh && !roleID){
                defer.resolve(roleConfigs);
            }else{
                var param = {req: { language: 'zh_CN'}};
                if(roleID){
                    param['req']['roleID'] = roleID;
                }
                //需要自定义错误
                OpenUp.getRoleConfig(param,true).then(function(res){
                    if(res.resultCode == 0 && res.roleConfigList){
                        //查询全部才缓存
                        if(!roleID){
                            roleConfigs = res.roleConfigList;
                        }
                        defer.resolve(res.roleConfigList);
                    }else{
                        defer.reject();
                    }
                },function(){
                    defer.reject();
                });
            }
            return defer.promise;
        }

        //查询一组角色是否需要签署开发者服务协议，只要其中有一个角色需要签署则签署，true:需要签署,false:不签署
        function shouldCheckDevAgree(roles) {
            var defer = $q.defer();
            getRoleConfigs().then(
                function (cfgs) {
                    var found = false;
                    //是否需要签署开发者联盟协议 1，需要 2不需要
                    for (var i = 0; roles && roles.length && cfgs && i < cfgs.length; i++) {
                        if (AUI.BaseJSUtil.contains(roles, cfgs[i].roleID) && cfgs[i].agreementSignType == 1) {
                            found = true;
                            break;
                        }
                    }
                    //如果没有角色则需要检查并签署开发者协议
                    if(!roles || roles.length == 0){
                        found =true;
                    }
                    defer.resolve(found);
                },function(){
                    defer.resolve(false);
                }
            );
            return defer.promise;
        }

        function addRole(roleId, channel){
            var defer = $q.defer();
            if(!roleId){
                defer.reject();
            }
            //channelType Integer 渠道类型，0：联盟，1：PPS，2：主体，3：应用推广，4：内容，5：职能家具，6：IOT
            OpenUp.addRole({req:{
                language: 'zh_CN',
                roleID: roleId,
                channelType: (channel ? channel : 0)
            }}).then(function(cfg){
                roleConfigs = cfg;
                defer.resolve(cfg);
            },function(){
                defer.reject();
            });
            return defer.promise;
        }

        /** true 是团队帐号*/
        function isTeamAccount(){
           return !!AUI.HDGWCall.getUserInfoValue('teamid');
        }

        //撤销实名认证,有参数：希望后台返回成功立即隐藏链接，无参数：不修改原来的数据
        function cancelDeveloperUpdate(pageUserInfo) {
            var defer = $q.defer();
            //接口调用成功之后，跳转
            UserInfo.cancelDeveloperUpdate().then(function (userInfo) {
                var dev = userInfo;
                if (dev && dev.verifyRealState === 1 && isFromPartner()) {
                    getChannelConfigs().then(function (channel) {
                        if (channel) {
                            AUI.BaseJSUtil.redirectUrl(channel.url);
                        }
                        defer.resolve();
                    }, function () {
                        defer.resolve();
                    });
                } else if (dev && dev.verifyRealState === 1 && !isFromPartner()) {
                    AUI.BaseJSUtil.redirectUrl(systemParaConf.user.indexUrl);
                    defer.resolve();
                } else if (dev && dev.verifyRealState === 2 && dev.updateRealState == 1 && dev.isChangeRealName != 1) {
                    //这个需要刷新右上角菜单以及横幅以及用户信息页面,暂时不用$window.location.reload()
                    $rootScope.$emit("stateChangedEvent", true);
                    if (dev.userType == 1) {
                        $state.go("mysetting.modUserInfoPer", {refresh: true}, {reload: true});
                    } else {
                        $state.go("mysetting.modUserInfoCorp", {refresh: true}, {reload: true});
                    }
                    //这个地方不改也可以，但是会出现链接不消失（1s内），为了提升体验，立即修改，后面会异步重新刷新数据
                    pageUserInfo && (pageUserInfo.updateInfo = '');
                    defer.resolve();
                } else {
                    defer.resolve();
                }
            }, function () {
                defer.reject();
            });
        }

        function getParam4Url() {
            var url = document.location.toString(); //获取带参URL
            var param_t = url.substring(url.lastIndexOf("?") + 1, url.length);
            var param_arr = param_t.split("&");//分离参数
            var out = [];
            angular.forEach(param_arr, function (v, idx, arr) {
                out = out.concat(v.split('='));
            });
            return out;
        }
        
        return {
            init: init,
            isFromPartner: isFromPartner,
            getPartnerParam: getPartnerParam,
            getRoleConfigs: getRoleConfigs,
            getChannelConfigs: getChannelConfigs,
            addRole: addRole,
            shouldCheckDevAgree: shouldCheckDevAgree,
            isTeamAccount: isTeamAccount,
            cancelDeveloperUpdate: cancelDeveloperUpdate,
            getParam4Url: getParam4Url
        };

    }])
});

